import { FC } from 'react'
import { IconArrowInbox, Button, Tooltip } from '@sequencehq/core-components'

import type { CreditNote } from 'CreditNotes/types'
import { useCreditNotePdfDownload } from 'CreditNotesList/useCreditNotePdfDownload'

type Props = {
  creditNoteId: CreditNote['id']
  creditNoteNumber: CreditNote['creditNoteNumber']
  creditNoteStatus: CreditNote['status']
}

export const ButtonDownloadCreditNotePdf: FC<Props> = ({
  creditNoteId,
  creditNoteNumber,
  creditNoteStatus
}) => {
  const { downloadPdf } = useCreditNotePdfDownload()
  const label = 'Download credit note as PDF'

  return (
    <Tooltip label={label}>
      <Button
        variant="secondary"
        icon={<IconArrowInbox color="inherit" />}
        aria-label={label}
        onClick={() =>
          downloadPdf({ creditNoteId, creditNoteNumber, creditNoteStatus })
        }
        data-testid="header.button.download-credit-note-pdf"
      />
    </Tooltip>
  )
}
